import React, { createContext, useContext, useEffect, useState } from 'react';
import { db, initializePowerSync } from './powersync-config';

const PowerSyncContext = createContext(null);

export const usePowerSync = () => {
  const context = useContext(PowerSyncContext);
  if (!context) {
    throw new Error('usePowerSync must be used within PowerSyncProvider');
  }
  return context;
};

export const PowerSyncProvider = ({ children }) => {
  const [isConnected, setIsConnected] = useState(false);
  const [isInitializing, setIsInitializing] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initialize = async () => {
      try {
        setIsInitializing(true);
        await initializePowerSync();
        setIsConnected(true);
        setError(null);
      } catch (err) {
        console.error('PowerSync initialization error:', err);
        setError(err?.message || String(err) || 'Unknown error occurred');
        setIsConnected(false);
      } finally {
        setIsInitializing(false);
      }
    };

    initialize();

    // Cleanup on unmount
    return () => {
      if (db) {
        db.disconnectAndClear().catch(console.error);
      }
    };
  }, []);

  const value = {
    db,
    isConnected,
    isInitializing,
    error
  };

  return (
    <PowerSyncContext.Provider value={value}>
      {children}
    </PowerSyncContext.Provider>
  );
};
